<script setup lang="ts">
import { computed, ref } from 'vue';
import {
  AuthorizationFilter,
  NumberFilter,
  DateFilter,
  RealTestCasesFilter,
  StatusFilter,
  StringFilter,
} from '../entities/Filters';
import {
  CaseListService,
  Contexts,
  getContainer,
  NamedBindings,
  TranslationService,
} from '@dandelion/core';
import { FilterInterface } from '@dandelion/core';

const caseListService = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CaseListService
) as CaseListService;
const ts = getContainer(Contexts.DEFAULT).get(
  NamedBindings.TranslationService
) as TranslationService;

const surname = ref('');
const name = ref('');
const birthDate = ref();
const endBirthDate = ref();
const admissionDate = ref();
const endAdmissionDate = ref();
const admissionKey = ref();
const coreStatus = ref();
const colonStatus = ref();
const liverStatus = ref();
const infectionStatus = ref();
const traumaStatus = ref();
const cchStatus = ref();
const esaStatus = ref();
const startStatus = ref();
const strokeStatus = ref();
const sex = ref('');
const consent = ref('');
const showSearch = ref(false);
const arrayOfFilter = new Array<FilterInterface>();

arrayOfFilter.push(new StringFilter('core.personalData.name', name));
arrayOfFilter.push(new StringFilter('core.personalData.surname', surname));
arrayOfFilter.push(new DateFilter('personalData.birthDate', birthDate,endBirthDate));
arrayOfFilter.push(
  new DateFilter('administrativeInfo.icuAdmDate', admissionDate,endAdmissionDate)
);
arrayOfFilter.push(new StringFilter('admissionKey', admissionKey));
arrayOfFilter.push(new StringFilter('core.personalData.sex', sex));
arrayOfFilter.push(new StatusFilter('core', coreStatus));
arrayOfFilter.push(new StatusFilter('colon', colonStatus));
arrayOfFilter.push(new StatusFilter('livertransplant', liverStatus));
arrayOfFilter.push(new StatusFilter('infections', infectionStatus));
arrayOfFilter.push(new StatusFilter('trauma', traumaStatus));
arrayOfFilter.push(new StatusFilter('cch', cchStatus));
arrayOfFilter.push(new StatusFilter('esa', esaStatus));
arrayOfFilter.push(new StatusFilter('start', startStatus));
arrayOfFilter.push(new StatusFilter('stroke', strokeStatus));
arrayOfFilter.push(new AuthorizationFilter('consent', consent));

const templateFilters = [
    {
    label: 'Name',
    type: 'text',
    name: 'name',
    model: name,
    length: '20',
    pattern: '[^0-9]*',
    show: ref(true),
  },{
    label: 'Surname',
    type: 'text',
    name: 'surname',
    model: surname,
    length: '20',
    pattern: '[^0-9]*',
    show: ref(true),
  },  {
    label: 'Chiave di Ammissione',
    type: 'text',
    name: 'admissionKey',
    model: admissionKey,
    length: '20',
    show: ref(true),
  },
  { label: 'Birth Date', type: 'date', name: 'birthDate', model: birthDate, show: ref(true) },
  { label: 'End Birth Date', type: 'date', name: 'endbirthDate', model: endBirthDate, show: showSearch},
  {
    label: 'Admission Date',
    type: 'date',
    name: 'admissionDate',
    model: admissionDate,
    show: showSearch,
  },
  {
    label: 'End Admission Date',
    type: 'date',
    name: 'endadmissionDate',
    model: endAdmissionDate,
    show: showSearch,
  }, { label: 'Core Status', type: 'number', name: 'coreStatus', model: coreStatus, show: showSearch, min:0,max:4 },
];
const statusTemplateFilters = [
   { label: 'Colon Status', type: 'number', name: 'colonStatus', model: colonStatus, show: showSearch, min:0,max:4 },
  { label: 'Liver Status', type: 'number', name: 'liverStatus', model: liverStatus, show: showSearch, min:0,max:4 },
  { label: 'Infections Status', type: 'number', name: 'infectionStatus', model: infectionStatus, show: showSearch, min:0,max:4 },
  { label: 'Trauma Status', type: 'number', name: 'traumaStatus', model: traumaStatus, show: showSearch, min:0,max:4 },  
  { label: 'CCH Status', type: 'number', name: 'cchStatus', model: cchStatus, show: showSearch, min:0,max:4 },
  { label: 'Esa Status', type: 'number', name: 'esaStatus', model: esaStatus, show: showSearch, min:0,max:4 },
  { label: 'Start Status', type: 'number', name: 'startStatus', model: startStatus, show: showSearch, min:0,max:4 },
  { label: 'Stroke Status', type: 'number', name: 'strokeStatus', model: strokeStatus, show: showSearch, min:0,max:4 }
]
setTimeout(async () => {
  await applyFilters();
}, 500);

const isSearchable = computed(() => {
  const fields = [
    'name',
    'surname',
    'admissionKey',
    'birthDate',
    'endBirthDate',
    'admissionDate',
    'endAdmissionDate',
    'coreStatus',
    'sex',
    'consent',
    'colonStatus',
    'liverStatus',
    'infectionStatus',
    'traumaStatus',    
    'cchStatus',
    'esaStatus',
    'startStatus',
    'strokeStatus',
  ];
  const currentFields = fields;
 return currentFields.some((field) => {
  const value = eval(field).value;
  return value !== "" && value !== null && value !== undefined;
});
});

async function resetFilters() {
  surname.value = '';
  name.value = '';
  admissionKey.value = '';
  birthDate.value = null;
  endBirthDate.value = null;
  admissionDate.value = null;
  endAdmissionDate.value = null;
  coreStatus.value = null;
  colonStatus.value = null;
  liverStatus.value = null;
  infectionStatus.value = null;
  traumaStatus.value = null;
  cchStatus.value = null;
  esaStatus.value = null;
  startStatus.value = null;
  strokeStatus.value = null;
  sex.value = '';
  consent.value = '';
}

async function cleanFilters() {
  await resetFilters();
  await caseListService.updateCaseList();
}

async function applyFilters() {
  await caseListService.setFilters(arrayOfFilter);
}

defineExpose({
  cleanFilters
});
</script>

<template>
  <form class="search-form" @submit.prevent="applyFilters">
    <div
      :class="{ 'all-filters': showSearch }"
      v-for="filter in templateFilters"
      v-show="filter.show.value"
      :for="filter.name"
    >
      <span v-html="ts.t(filter.label)"></span>
      <input
        class="input input-bordered"
        :type="filter.type"
        :maxlength="filter.length"
        :name="filter.name"
        :pattern="filter.pattern"
        :min="filter.min"
        :max="filter.max"

        v-model="filter.model.value"
      />
    </div>
    <template v-if="showSearch">
      <div :class="{ 'all-filters': showSearch }">
        <span v-html="ts.t('Gender')"></span>
        <select name="sex" v-model="sex">
          <option value=""></option>
          <option value="sexCodification.male" v-html="ts.t('Male')"></option>
          <option
            value="sexCodification.female"
            v-html="ts.t('Female')"
          ></option>
        </select>
      </div>
      <div :class="{ 'all-filters': showSearch }">
        <span v-html="ts.t('Consent signed')"></span>
        <select name="patientAuthorizationSynch" v-model="consent">
          <option value=""></option>
          <option value="signed" v-html="ts.t('Signed')"></option>
          <option value="notSigned" v-html="ts.t('Not signed')"></option>
          <option value="notNecessary" v-html="ts.t('Not necessary')"></option>
        </select>
      </div>
      <details class="status-details">
      <summary>Filtri Status</summary>
      <div  class="status-filters">
      <div
      :class="{ 'all-filters': showSearch }"
      v-for="filter in statusTemplateFilters"
      v-show="filter.show.value"
      :for="filter.name"
    >
      <span v-html="ts.t(filter.label)"></span>
      <input
        class="input input-bordered"
        :type="filter.type"
        :name="filter.name"
        :min="filter.min"
        :max="filter.max"

        v-model="filter.model.value"
      /></div>
    </div></details>
    </template>
    <section :class="{ 'section-expanded': showSearch }">
      <button
        id="other-filters"
        class="primary"
        @click="showSearch = true"
        v-show="!showSearch"
        v-html="ts.t('Other filters')"
      ></button>
      <button
        v-if="showSearch"
        id="close-search"
        @click="showSearch = false"
        v-html="ts.t('Less filters')"
      ></button>
      <div>
        <button
          id="reset-btn"
          type="reset"
          class="secondary"
          @click="cleanFilters"
          v-html="ts.t('Clean')"
        ></button>
        <button
          @click="$emit('closeSearch')"
          id="search-btn"
          type="submit"
          class="primary"
          :disabled="!isSearchable"
          v-html="ts.t('Search')"
        ></button>
      </div>
    </section>
  </form>
</template>

<style scoped>
.search-form {
  row-gap: 1rem;
}

.search-form section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem;
}

.search-form > div {
  display: flex;
  align-items: center;
  margin: 1rem;
}

.search-form div > span {
  display: inline-block;
  min-width: 18ch;
  margin-right: 3rem;
}

.search-form div > span.input-span {
  min-width: 0;
  margin: 0 1.75rem 0 0.75rem;
}

.search-form input,
.search-form select {
  width: 100%;
  border: 1px solid #dadada;
  background-color: #ebf0f3 !important;
}

.search-form select {
  border-radius: 0.5rem;
  padding: 0 1rem;
  height: 3rem;
}

.search-form input[type='radio'] {
  width: min-content;
  margin: 0;
}

#reset-btn {
  margin-right: 0.6rem;
}
.all-filters{

}
.status-details{

  flex: 1 1 100%;

}
.status-filters{
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 1rem;
  row-gap: 1rem;
}
.status-filters > div {
  display: flex;
  align-items: center;
  margin: 1rem;
}

@media only screen and (max-width: 792px) {
  .search-form {
    grid-template-columns: 100% !important;
    max-width: fit-content;
    margin-left: 20%;
    margin-right: 20%;
  }

  .search-form section {
    grid-row: 4 !important;
    grid-column: 1 !important;
    text-align: right;
  }

  .section-expanded {
    grid-row: 6 !important;
  }
}
</style>
